import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballTeamService } from "../../../../../../commons";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";

interface ITeamDeleteState {
  subTeamDeleteStatus: StatusEnum;
}

const initialState: ITeamDeleteState = {
  subTeamDeleteStatus: StatusEnum.Idle,
};

export interface subTeamDeleteOption {
  teamId: number;
  subTeamId: number;
}

export const subTeamDelete = createAsyncThunk(
  "manage/subTeamDelete",
  async (options: subTeamDeleteOption, thunkAPI) => {
    try {
      const subTeamDeleteResponse = await manageFootballTeamService.removeSubTeam(options.teamId, options.subTeamId);
      return subTeamDeleteResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const subTeamDeleteSlice = createSlice({
  name: "subTeamDelete",
  initialState: initialState,
  reducers: {
    cleanUpTeamDelete(state) {
      state.subTeamDeleteStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(subTeamDelete.pending, (state) => {
        state.subTeamDeleteStatus = StatusEnum.Loading;
      })
      .addCase(subTeamDelete.fulfilled, (state, action) => {
        state.subTeamDeleteStatus = StatusEnum.Succeeded;
      })
      .addCase(subTeamDelete.rejected, (state) => {
        state.subTeamDeleteStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamDelete } = subTeamDeleteSlice.actions;
export default subTeamDeleteSlice.reducer;
